import { defineMessages } from "react-intl";
export const messages = defineMessages({
    genericError: {
        id: "change_contract.error.generic",
        defaultMessage: "An error occured."
    },
    header: {
        id: "change_contract.header",
        defaultMessage: "Transfer or modify contract"
    },
    header_modify: {
        id: "change_contract.header_modify",
        defaultMessage: "Modify leasing"
    },
    header_transfer: {
        id: "change_contract.header_transfer",
        defaultMessage: "Transfer contract"
    },
    header_extend: {
        id: "change_contract.header_extend",
        defaultMessage: "Extend contract"
    },
    regNumber: {
        id: "change_contract.regNumber",
        defaultMessage: "Registration number"
    },
    regNumber_short: {
        id: "change_contract.regNumber_short",
        defaultMessage: "Reg. number"
    },
    contractNumber: {
        id: "change_contract.contractNumber",
        defaultMessage: "Contract number"
    },
    customerName: {
        id: "change_contract.customerName",
        defaultMessage: "Customer"
    },
    objectDescription: {
        id: "change_contract.objectDescription",
        defaultMessage: "Model/Type"
    },
    termAmount: {
        id: "change_contract.termAmount",
        defaultMessage: "Term amount"
    },
    serviceAmount: {
        id: "change_contract.serviceAmount",
        defaultMessage: "Service amount"
    },
    warnings: {
        id: "change_contract.warnings",
        defaultMessage: "Warnings"
    },
    typeOfChange: {
        id: "change_contract.typeOfChange",
        defaultMessage: "Type of change"
    },
    productCode: {
        id: "change_product.productType",
        defaultMessage: "Product type"
    },
    selectProduct: {
        id: "change_contract.selectProduct",
        defaultMessage: "Select product"
    },
    dateForTransfer: {
        id: "change_contract.dateForTransfer",
        defaultMessage: "Transfer date"
    },
    dateForModification: {
        id: "change_contract.dateForModification",
        defaultMessage: "Modification date"
    },
    next: {
        id: "change_contract.next",
        defaultMessage: "Next"
    },
    search: {
        id: "change_contract.search",
        defaultMessage: "Search"
    },
    invalidRegNumber: {
        id: "change_contract.invalidRegNumber",
        defaultMessage: "Invalid registration number"
    },
    cancel: {
        id: "change_contract.cancel",
        defaultMessage: "Cancel"
    },
    remainingTermsCount: {
        id: "change_contract.remainingTermsCount",
        defaultMessage: "Remaining terms count"
    }
});
//# sourceMappingURL=messages.js.map